import { useListContext } from "ra-core";
import { ReferenceManyField } from "@/components/admin/reference-many-field";

import type { Contact } from "../types";
import { Avatar as ContactAvatar } from "../contacts/Avatar";

const MAX_AVATARS = 3;

const AvatarGroupIterator = () => {
  const { data, total, error, isPending } = useListContext();
  if (isPending || error) return null;

  return (
    <div className="*:data-[slot=avatar]:ring-background flex -space-x-0.5 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:grayscale-50">
      {data.slice(0, MAX_AVATARS).map((record) => (
        <ContactAvatar
          key={record.id}
          record={record as Contact}
          width={25}
          height={25}
          title={`${record.first_name ?? ""} ${record.last_name ?? ""}`.trim()}
        />
      ))}
      {total > MAX_AVATARS && (
        <span
          className="relative flex size-8 shrink-0 overflow-hidden rounded-full w-[25px] h-[25px]"
          data-slot="avatar"
        >
          <span className="bg-muted flex size-full items-center justify-center rounded-full text-[10px]">
            +{total - MAX_AVATARS}
          </span>
        </span>
      )}
    </div>
  );
};

export const CompanyContactAvatarGroup = ({
  nbContacts,
}: {
  nbContacts?: number;
}) => {
  if (!nbContacts) return null;

  return (
    <ReferenceManyField reference="contacts" target="company_id">
      <AvatarGroupIterator />
    </ReferenceManyField>
  );
};
